<script>
    import TopList from '../components/TopList.svelte';
    import { onMount } from 'svelte';
    
    let collectionPageJsonLd = null;
    
    onMount(() => {
        // Create CollectionPage schema for authoritative comparison lists
        collectionPageJsonLd = {
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            name: "Topplista över bostadsrättsföreningar",
            description: "Jämför och utforska bostadsrättsföreningar baserat på vårt betygsystem. Se de bästa och sämsta föreningarna med detaljerad information om ekonomi, avgifter med mera.",
            url: "https://boanalys.io/toplist",
            mainEntity: {
                "@type": "ItemList",
                name: "Bostadsrättsföreningar Rankade efter Betyg",
                description: "En auktoritativ lista över bostadsrättsföreningar rankade efter ekonomiskt betyg, baserat på omfattande analys av årsredovisningar, stadgar och energideklarationer.",
            },
            publisher: {
                "@type": "Organization",
                name: "Boanalys",
                url: "https://boanalys.io",
            },
            about: {
                "@type": "Thing",
                name: "Bostadsrättsföreningar",
                description: "Jämförelse och analys av bostadsrättsföreningar i Sverige",
            },
        };
    });
</script>

<svelte:head>
	<title>Topplista över bostadsrättsföreningar | Boanalys</title>
	<meta
		name="description"
		content="Jämför och utforska bostadsrättsföreningar baserat på vårt betygsystem. Se de bästa och sämsta föreningarna med detaljerad information om ekonomi, avgifter med mera."
	/>
	<link rel="canonical" href="https://boanalys.io/toplist" />
	
	<!-- Open Graph / Facebook -->
	<meta property="og:type" content="website" />
	<meta property="og:url" content="https://boanalys.io/toplist" />
	<meta property="og:title" content="Topplista över bostadsrättsföreningar | Boanalys" />
	<meta property="og:description" content="Jämför och utforska bostadsrättsföreningar baserat på vårt betygsystem. Se de bästa och sämsta föreningarna." />
	<meta property="og:image" content="https://boanalys.io/bo-emblem-black.png" />
	
	<!-- Twitter -->
	<meta property="twitter:card" content="summary_large_image" />
	<meta property="twitter:url" content="https://boanalys.io/toplist" />
	<meta property="twitter:title" content="Topplista över bostadsrättsföreningar | Boanalys" />
	<meta property="twitter:description" content="Jämför och utforska bostadsrättsföreningar baserat på vårt betygsystem. Se de bästa och sämsta föreningarna." />
	<meta property="twitter:image" content="https://boanalys.io/bo-emblem-black.png" />
	
	{#if collectionPageJsonLd}
		{@html `<script type="application/ld+json">${JSON.stringify(collectionPageJsonLd)}</script>`}
	{/if}
</svelte:head>

<div class="page-container">
    <TopList />
</div>